/**
 * ContractExpirationsByYearChart export with lazy loading
 *
 * Lazy loads the Victory-based bar chart to reduce initial bundle size.
 */

/* eslint-disable component-structure/enforce-component-structure -- Intentional lazy wrapper pattern */
import React, { ComponentProps, lazy, memo, Suspense } from "react";

import ChartSkeleton from "@/components/molecules/ChartSkeleton";

const ContractExpirationsByYearChartContainer = lazy(
  () => import("./ContractExpirationsByYearChartContainer")
);

/** Props for the lazy-loaded ContractExpirationsByYearChart component */
type ContractExpirationsByYearChartProps = ComponentProps<
  typeof ContractExpirationsByYearChartContainer
>;

/**
 * Lazy-loaded ContractExpirationsByYearChart wrapper with loading fallback.
 * @param props - ContractExpirationsByYearChartContainer props
 */
const LazyContractExpirationsByYearChart = memo(
  (props: ContractExpirationsByYearChartProps) => (
    <Suspense fallback={<ChartSkeleton />}>
      <ContractExpirationsByYearChartContainer {...props} />
    </Suspense>
  )
);

LazyContractExpirationsByYearChart.displayName =
  "LazyContractExpirationsByYearChart";

export default LazyContractExpirationsByYearChart;
/* eslint-enable component-structure/enforce-component-structure -- Re-enable after lazy wrapper */
